import { render, staticRenderFns } from "./SalonEditarTipos.vue?vue&type=template&id=59e82768&"
import script from "./SalonEditarTipos.vue?vue&type=script&lang=js&"
export * from "./SalonEditarTipos.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports